module.exports = __webpack_public_path__ + "static/media/paso_a_paso.7e03df62.png";